import { render, staticRenderFns } from "./CustomersManager.vue?vue&type=template&id=772b5076&"
import script from "./CustomersManager.vue?vue&type=script&lang=js&"
export * from "./CustomersManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports